import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faSearch,
  faPlus,
  faEllipsisH,
  faEdit,
  faTrashAlt,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Nav,
  Row,
  Form,
  Pagination,
  Card,
  Table,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
  Badge,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import axios from "axios";
import swal from "sweetalert";
import {
  getProjectAnnoucements,
  deleteProjectAnnoucement,
} from "../../app/api";
import Loader from "../../components/Loader";
import moment from 'moment'
export default () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [project, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const fetchProjectAnnoucement = async (currentPage) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getProjectAnnoucements(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
          search,
        },
      });
      // console.log(response.data);

      setProjects(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false); // Hide loader after fetching data
    }
  };

  useEffect(() => {
    fetchProjectAnnoucement(page);
  }, [page, search]);
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(deleteProjectAnnoucement(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      swal({
        text: response.data.message,
        icon: "success",
      });
    } catch (error) {
      // console.error("Error fetching vendors:", error);
     swal({
            text: error.response.data.messages.error,
            icon: "error",
          });
    }
    fetchProjectAnnoucement(page);
  };

  return (
    <>
      <div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
          <div className="d-block mb-md-0">
            {/* <Breadcrumb
              className="d-none d-md-inline-block"
              listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
            >
              <Breadcrumb.Item>
                <FontAwesomeIcon icon={faHome} />
              </Breadcrumb.Item>
            
              <Breadcrumb.Item active>Project Announcement</Breadcrumb.Item>
            </Breadcrumb> */}
            <h4 className="mb-0">Project Announcements Management</h4>
            {/* <p className="mb-0">Your web analytics dashboard template.</p> */}
          </div>
          <Col xs={12} md={4} lg={4} xl={4} className=" mb-sm-2">
              <InputGroup>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </Col>
          <Button
            variant="primary"
            className=" me-2"
            as={Link}
            to={Routes.AddProjectAnnoucement.path}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            <span>New</span>
          </Button>
        </div>

        {/* <div className="table-settings mb-4">
          <Row className="justify-content-between align-items-center">
           
          </Row>
        </div> */}
        <Card
          border="light"
          className="table-wrapper table-responsive shadow-sm"
        >
          <Card.Body className="p-0">
            <Table hover className="user-table align-items-center">
              {loading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </div>
              ) : (
                <>
                  <thead>
                    <tr>
                      {/* <th className="border-bottom">ID</th> */}
                      <th className="border-bottom">Title</th>
                      <th className="border-bottom">Deadline</th>
                      <th className="border-bottom">Status</th>

                      <th className="border-bottom">Sending Announcement</th>
                      <th className="border-bottom">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {project.map((projects, index) => (
                      <tr key={index}>
                        {/* <td className="fw-normal">{projects?.id}</td> */}
                        <td>
                          <span className="fw-normal">
                            {" "}
                            <Link
                              className="Link_underline"
                              to={`${Routes.ProjectAnnoucementDetail.path}/${projects.id}`}
                            >
                              {projects?.title}{" "}
                            </Link>
                          </span>
                        </td>
                        <td>
                          <span className="fw-normal">
                            
                            {moment(projects?.deadline).format("MM/DD/YYYY")}
                          </span>
                        </td>

                        <td>
                          <span className="fw-normal">
                            {" "}
                            <Badge
                              pill
                              bg="primary"
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.85rem",
                                border: "1px solid #ddd",
                              }}
                            >
                              {projects?.active === "1" ? "Active" : "InActive"}
                            </Badge>
                          </span>
                        </td>
                        <td>
                          {" "}
                          <Button
                            variant="secondary"
                            className="text-dark me-2"
                            as={Link}
                            to={`${Routes.VendorsProjectAnnocement.path}/${projects.id}`}
                          >
                            <FontAwesomeIcon
                              icon={faPaperPlane}
                              className="me-2"
                            />
                            <span>Send</span>
                          </Button>
                        </td>

                        <td>
                          <Dropdown as={ButtonGroup}>
                            <Dropdown.Toggle
                              as={Button}
                              split
                              variant="link"
                              className="text-dark m-0 p-0"
                            >
                              <span className="icon icon-sm">
                                <FontAwesomeIcon
                                  icon={faEllipsisH}
                                  className="icon-dark"
                                />
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item>
                                <Link
                                  className="me-2"
                                  to={`${Routes.ProjectAnnoucementDetail.path}/${projects.id}`}
                                >
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    className="me-2"
                                  />{" "}
                                  View Details
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item>
                                <Link
                                  as={Link}
                                  to={`${Routes.AddProjectAnnoucement.path}/${projects.id}`}
                                >
                                  <FontAwesomeIcon
                                    icon={faEdit}
                                    className="me-2"
                                  />{" "}
                                  Edit{" "}
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item className="text-danger">
                                <div onClick={() => handleDelete(projects.id)}>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    className="me-2"
                                  />{" "}
                                  Remove
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </>
              )}
            </Table>
            <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">
              <Nav className="justify-content-center mb-4">
                <Pagination className="mb-2 mb-lg-0">
                  <Pagination.Prev
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  />
                  {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === page}
                      onClick={() => setPage(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalPages))
                    }
                  />
                </Pagination>
              </Nav>
            </Card.Footer>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
